<template>
  <div class="quote" @click="clicked" role="button" v-ripple>
    <span class="q"></span>
    <div style="width:100%;">
      <div class="author" v-if="!deleted">
        {{message.authorName}}
      </div>

      <div v-if="hasPreview"
        class="preview" 
        :style="{ 'background-image': 'url(' + message.data.preview + ')' }"
      ></div>
      <div v-else 
        :class="contentClass">
        {{content}}
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  .quote {
    padding: 8px 16px 0px 16px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    display: flex;
    cursor: pointer;

    .q {
      background-color: var(--v-accent-lighten1);
      width: 2px;
      flex: none;
      margin: 0px 8px 0px 0px;
    }
    .content {
      line-height: 21px;
      max-height: 63px;
      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
    .deleted {
      color: var(--secondary-text);
    }
    .author {
      color: var(--v-accent-lighten1);
    }
    .preview {
      width: 96px;
      height: 60px;
      background-repeat: no-repeat;
      background-position: center;
      background-position-x: center;
      background-size:cover;
      border-radius: inherit;
    }
  }
</style>

<script>
  import {EventBus} from '@/event-bus'

  export default {
    name: 'message-quote',
    props: {
      message: Object,
    },
    computed: {
      deleted() {
        return Object.keys(this.message).length === 0
      },
      content() {
        if (this.deleted) 
          return this.$t('message_was_deleted')

        switch (this.message.type) {
          //case this.types.ContactMessage:
          //  return '@' + this.message.content
          case this.types.DocumentMessage:
            return this.message.data.name        
          case this.types.AudioMessage:
            return this.$t('media_type_audio')
          case this.types.LocationMessage:
            return this.$t('chet_menu_location')
        }
        return this.message.content
      },
      contentClass() {
        return ['content', this.deleted ? 'deleted' : '']
      },
      hasPreview() {
        return (!this.deleted) ? this.message.data.preview : false
      }
    },
    methods: {
      clicked() {
        if (!this.deleted)
          EventBus.$emit('view-message', this.message.id)
      }
    }
  }
</script>
